export default "__VITE_ASSET__BDcb5veI__"